module.exports = __webpack_public_path__ + "img/btc.77d69588.svg";